import {
  MilestoneStatusName,
  useMilestoneDetailSectionQuery
} from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export interface IData {
  id: string;
  title: string;
  description: string;
  estimatedStartDate?: DateTime;
  startDate?: DateTime | null;
  endDate?: DateTime | null;
  durationInDays: number;
  status: MilestoneStatusName;
}

export function useQuery(id: string) {
  const tuple = useMilestoneDetailSectionQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.milestone?.id ?? '',
        title: tuple.data?.milestone?.title ?? '',
        description: tuple.data?.milestone?.description ?? '',
        startDate: tuple.data?.milestone?.startDate ?? null,
        endDate: tuple.data?.milestone?.endDate,
        durationInDays: tuple.data?.milestone?.durationInDays ?? 0,
        status: tuple.data?.milestone?.status.name ?? 'open'
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
